export enum BlockUserReasonEnum {
  BlockedBySystem,
  ExceedingOfPowers,
  UnauthorizedUser
}
